<button (click)="createNewWorkspace()">Create New Workspace</button>
<button (click)="getWorkspace()">Get Workspace</button>